export const PLAN_FREE = 'free'

// There is no number for "unlimited," so I give folks 10,000 monthly posts instead.
export const MAGIC_UNLIMITED_NUMBER = 10000

export const isPaidPlan = (plan) => {
  return plan.monthlyPrice > 0.0
}

export const isUpgrade = (currentPlan, newPlan) => {
  return currentPlan.monthlyPrice < newPlan.monthlyPrice
}

export const isDowngrade = (currentPlan, newPlan) => {
  return currentPlan.monthlyPrice > newPlan.monthlyPrice
}
